﻿import { Link, NavLink, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About' },
    { to: '/programs', label: 'Programs' },
    { to: '/news', label: 'News' },
    { to: '/contact', label: 'Contact' },
    { to: '/empowering-women-restore-grazing-lands-kisapuk', label: 'Empowering Women' },
  ];

  const showWhiteLogo = !scrolled && location.pathname === '/';

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 shadow-sm backdrop-blur-md' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-[90px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        {/* Logo Container - Responsive sizes */}
        <Link
          to="/"
          className="flex items-center justify-center rounded-full transition-all duration-300
            h-[56px] w-[56px]        /* Mobile */
            sm:h-[64px] sm:w-[64px]   /* Tablet */
            lg:h-[72px] lg:w-[72px]   /* Desktop */"
          onClick={() => setOpen(false)}
        >
          {/* Logo Image - Matches container proportions and is slightly inset */}
          <img
            src={showWhiteLogo ? '/logo-white.png' : '/logoo.png'}
            alt="Kisapuk Community Initiative Logo"
            className="object-contain object-center transition-all duration-300 ease-out filter drop-shadow-md
              h-[48px] w-[48px]        /* Mobile */
              sm:h-[56px] sm:w-[56px]  /* Tablet */
              lg:h-[64px] lg:w-[64px]  /* Desktop */"
          />
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 text-sm font-semibold tracking-wide transition-colors ${
                  isActive
                    ? scrolled
                      ? 'bg-brand-50 text-brand-700'
                      : 'bg-white/10 text-gold-400'
                    : scrolled
                    ? 'text-stone-700 hover:bg-stone-100 hover:text-brand-700'
                    : 'text-white/90 hover:bg-white/10 hover:text-white'
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </div>

        <button
          className={`flex h-11 w-11 items-center justify-center rounded-full border transition-colors md:hidden ${
            scrolled
              ? 'border-stone-200 text-stone-700 hover:bg-stone-100'
              : 'border-white/20 bg-white/10 text-white hover:bg-white/20'
          }`}
          onClick={() => setOpen(!open)}
          aria-label="Toggle Menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-stone-200 bg-white/95 backdrop-blur-sm md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-4 sm:px-6">
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-xl px-4 py-3 text-sm font-semibold transition-colors ${
                    isActive
                      ? 'bg-brand-50 text-brand-700'
                      : 'text-stone-700 hover:bg-stone-100 hover:text-brand-700'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}